<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch6">
<div class="chapterHead">
<p class="centerImage3"><img alt="image" src="images/ch6.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;"><a id="pg-6">Debbie is standing by herself in the corner. You figure Nick and Connor must still be in the kitchen. You approach cautiously.</a></p><a id="pg-6">
<p class="para" style="text-indent: 5%;">“Do you really think this scavenger hunt is for real?” she asks, glancing toward the kitchen.</p>
<p class="para" style="text-indent: 5%;">“Yeah,” you say. “You guys <em class="italic">promised</em> that you’ll let me go if I find the items by midnight.”</p>
<p class="para" style="text-indent: 5%;">Debbie starts laughing — a hideous cackling laugh. “Fool!” she cries. “It’s a joke! You’re never going to make it out!”</p>
<p class="para" style="text-indent: 5%;">You don’t know whether to believe her or not.</p>
<p class="para" style="text-indent: 5%;">“What do you mean?” you ask.</p>
<p class="para" style="text-indent: 5%;">Debbie slithers closer. “I’m on your side,” she whispers. “I used to be a regular kid like you. Then I joined the Horror Club. Now look what’s happened to me!”</p>
<p class="para" style="text-indent: 5%;">You stare in amazement at Debbie’s hideous monster face. Is she for real? Was she really once a kid like you?</p>
<p class="para" style="text-indent: 5%;">“I want to help you,” she says. “If you follow me, I’ll help you escape.”</p>
</a><p class="extractLetterText" style="text-indent: 5%;"><a id="pg-6"><em class="italic">If you think Debbie is telling the truth, follow her on </em></a><span href="#/e9780545841030_ch086" title="Link target outside of Sample"><em class="italic">PAGE 86</em></span>.</p>
<p class="para" style="text-indent: 5%;"><em class="italic">If you think it’s best to continue the hunt, turn to <span href="#/e9780545841030_ch016" title="Link target outside of Sample"><em class="italic">PAGE 16</em></span>.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841030_ch006.vue?c2e3363a